import pic from "../assets/tpic.png"

export const previewarray=[
    {
        "text":"Mon"
    },
    {
        "text":"10:00AM - 06:00PM"
    },
    {
        "text":"Tue"
    },
    {
        "text":"24h"
    },
    {
        "text":"Wed"
    },
    {
        "text":"10:00AM - 06:00PM"
    },
    {
        "text":"10:00AM - 06:00PM"
    },
    {
        "text":"Fri"
    },
    {
        "text":"10:00AM - 06:00PM"
    },
]
export const MonitorData=[
    {
       "num":"#00019298812" ,
       "link":"www.123Directories.com",
       "name":"Adam Person",
       "data":"02/09/2022",
       "dname":"by Adam Person",
       "img":pic
    },
    {
        "num":"#00019298812" ,
        "link":"www.123Directories.com",
        "name":"Adam Person",
        "data":"02/09/2022",
        "dname":"by Adam Person",
        "img":pic
     },
     {
        "num":"#00019298812" ,
        "link":"www.123Directories.com",
        "name":"Adam Person",
        "data":"02/09/2022",
        "dname":"by Adam Person",
        "img":pic
     },
     {
        "num":"#00019298812" ,
        "link":"www.123Directories.com",
        "name":"Adam Person",
        "data":"02/09/2022",
        "dname":"by Adam Person",
        "img":pic
     },
     {
        "num":"#00019298812" ,
        "link":"www.123Directories.com",
        "name":"Adam Person",
        "data":"02/09/2022",
        "dname":"by Adam Person",
        "img":pic
     },
]
export const MonitorData1=[
    {
       "img":pic,
       "one":"Image.jpg",
       "two":"Image|jpg|2024x1200 PX|1.2MB",
       "three":"02/09/2022 | Uploaded by Adam Person",
       "four":"02/09/2022 | Last edit by Adam Person",
       "five":"Valid Licence",
       "six":"Expire in 265 Days",
       "seven":"Instances",
       "eight":"Home",
       "nine":"Contact"
    }, {
        "img":pic,
        "one":"Image.jpg",
        "two":"Image|jpg|2024x1200 PX|1.2MB",
        "three":"02/09/2022 | Uploaded by Adam Person",
        "four":"02/09/2022 | Last edit by Adam Person",
        "five":"Valid Licence",
        "six":"Expire in 265 Days",
        "seven":"Instances",
        "eight":"Home",
        "nine":"Contact"
     },
     {
        "img":pic,
        "one":"Image.jpg",
        "two":"Image|jpg|2024x1200 PX|1.2MB",
        "three":"02/09/2022 | Uploaded by Adam Person",
        "four":"02/09/2022 | Last edit by Adam Person",
        "five":"Valid Licence",
        "six":"Expire in 265 Days",
        "seven":"Instances",
        "eight":"Home",
        "nine":"Contact"
     },
     {
        "img":pic,
        "one":"Image.jpg",
        "two":"Image|jpg|2024x1200 PX|1.2MB",
        "three":"02/09/2022 | Uploaded by Adam Person",
        "four":"02/09/2022 | Last edit by Adam Person",
        "five":"Valid Licence",
        "six":"Expire in 265 Days",
        "seven":"Instances",
        "eight":"Home",
        "nine":"Contact"
     },
     {
        "img":pic,
        "one":"Image.jpg",
        "two":"Image|jpg|2024x1200 PX|1.2MB",
        "three":"02/09/2022 | Uploaded by Adam Person",
        "four":"02/09/2022 | Last edit by Adam Person",
        "five":"Valid Licence",
        "six":"Expire in 265 Days",
        "seven":"Instances",
        "eight":"Home",
        "nine":"Contact"
     },
   
]